<template>
  <div>
    <v-simple-table class="uvtable">
      <thead>
        <th width="10%" style=" position: sticky; top: 0;">HORA</th>
        <template v-for="(bah, index) in comp_bahias">
          <th
            :width="compSizeOfColumns"
            style="
              
              text-align: center;
              
              cursor: pointer;
              position: sticky;
              top: 0;
            "
            :key="index"
          >
            <div
              v-bind:class="{
                selectBayHeader: index == selectedSlot,
                disableClick: !creationMode,
              }"
            >
              {{ bah.Name }}
            </div>
          </th>
        </template>
      </thead>
      <tbody class="list">
        <template v-for="(time, index) in horas">
          <tr
            v-show="display(time.time)"
            v-bind:class="{
              disableClick: !creationMode,
            }"
            :key="index"
          >
            <td class="timeCell" style="font-size: 12px">
              <h5>{{ time.time }} - {{ time.timeEnd }}</h5>
            </td>

            <template v-for="(bah, ind) in comp_bahias">
              <td
                class="cell"
                v-bind:class="{
                  selectBay: ind == selectedSlot,
                  disableBay: ind != selectedSlot && !time.block[ind + 1],
                  ocuped:(time.Privado),
                  selectedTime: time.selected[ind + 1] || time.final[ind + 1],
                  selectedRange: time.inRange[ind + 1],
                  disableClick: !creationMode,
                }"
                @click="
                  !time.block[ind + 1]
                    ? selectTime(time.time, time.timeEnd, ind)
                    : 'test'
                "
                style="border: solid 1px #e8e9e9 !important"
                :key="ind"
              >
                <template v-if="time.block[ind + 1]">
                  <div v-if="time.ResData[ind + 1]">
                  <template
                    v-for="(r, indexr) in time.ResData[ind + 1].dataReserva"
                  >
                    <v-card
                      :key="indexr + '-' + ind"
                      v-if="r.E != 'C'"
                      v-bind:style="{
                        color: rowTextColor(r),
                      }"
                      :color="rowColor(r)"
                      class="pa-2"
                      @click="
                        showDetail(
                          time.players[ind + 1],
                          r.Nom,
                          time.ResData[ind + 1],
                          r
                        )
                      "
                    >
                      <h4 style="font-size: 13px; margin: 0">
                        <span style="font-size: 13px">{{ r.Nom }} </span>
                      </h4>

                      <h5 class="ma-0">
                        {{ r.frva }}
                      </h5>
                      <h5 class="ma-0">
                        {{ r.fvta }}
                      </h5>
                    </v-card>
                  </template>
                  </div>
                  <div v-if="time.Privado">
                  {{time.Privado.Mtv}}
                  </div>
                </template>
                <template v-if="time.selected[ind + 1]">
                  <h3>{{ time.time }}</h3>
                </template>
                <template v-if="time.final[ind + 1]">
                  <h3>{{ time.timeEnd }}</h3>
                </template>
              </td>
            </template>
          </tr>
        </template>
      </tbody>
    </v-simple-table>

    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      max-width="600"
    >
      <v-card>
        <v-toolbar color="primary" dark
          ><h2>Detalle de reserva</h2>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" icon dark>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="text-h6  mt-5">Cliente:{{ dataDetail.playerName }}</div>
          <div class="text-h6">Bahia :{{ dataDetail.bahia }}</div>
          <div class="text-h6">
            Horario :{{ dataDetail.HInicial }} - {{ dataDetail.HFinal }}
          </div>
          <div class="text-h6">Jugadores :</div>
          <div v-if="dataDetail.dataReserva">
          <template v-for="(resData, indexRes) in dataDetail.dataReserva">
            <v-list dense :key="indexRes">
              <template v-for="(ply, index) in resData.Pys">
                <v-list-item :key="index">
                  <v-list-item-content>
                    {{ ply.Nom }}<br />

                    {{ ply.trfr }} <br />
                    {{ ply.prco.C }} {{ ply.prco.M }}
                  </v-list-item-content>
                  <v-chip label small color="danger" v-if="ply.E == 'C'"
                    >Cancelado</v-chip
                  >
                  <v-chip label small color="success" v-if="ply.E == 'P'"
                    >Pagado</v-chip
                  >
                  <v-chip label small color="primary" v-if="ply.E == 'R'"
                    >Reservado</v-chip
                  >
                </v-list-item>
              </template>
            </v-list>
          </template>
          </div>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn s color="primary" dark @click="sendToEdit(dataDetail.id)">
            Editar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "ActivityTimes",
  components: {},
  props: [
    "creationMode",
    "reservasData",
    "times",
    "time",
    "price",
    "players",
    "privado",
    "reservados",
    "prefered",
    "tarifaId",
    "priceGlobal",
    "isAdmin",
    "selectedDate",
    "playersName",
    "showAll",
    "slotsNumber",
    "selectedSlot",
  ],
  data() {
    return {
      selectedTimes: [],
      dialog: false,
      dataDetail: {
        numPlayers: "",
        playerName: "",
        HInicial: "",
        HFinal: "",
        id: "",
      },
      selectedBay: -1,
      clicked: false,
      personLimit: 6,
      count: 1,
      actualDate: moment(),
    };
  },
  methods: {
    rowTextColor(data) {
      let color =
        data.colr == "D"
          ? "white"
          : data.colr == "M"
          ? "white"
          : this.$pgsHelper.invertColor(data.colr);
      if (data.E == "P") {
        return "white";
      }
      if (data.deda) {
        return "white";
      }
      return color;
    },
    rowColor: function(data) {
      let color =
        data.E == "R"
          ? data.colr == "D"
            ? "blue"
            : data.colr == "M"
            ? "orange"
            : data.colr || "blue"
          : data.E == "P"
          ? "green"
          : "red";
      if (data.deda) {
        return "#9d0b00";
      }

      return color;
    },
    sendToEdit(id) {
      this.dialog = false;
      this.$emit("editClick", id);
    },
    sendToPDV(id) {},
    showDetail(numPlayers, playerName, res, r) {
      this.dataDetail = {
        numPlayers: numPlayers,
        playerName: playerName,
        HInicial: res.inicial,
        HFinal: res.final,
        id: r.id,
        ...res,
      };

      this.dialog = true;
    },
    selectBay(index) {
      this.selectedBay = index;
      this.selectedTimes = [];
      this.$emit("cleanTimesRange");
    },
    init() {},
    enableClick: function(time) {
      let show = false;

      if (
        this.actualDate.format("YYYY-MM-DD HH:mm") >
        moment(
          this.selectedDate.format("YYYY-MM-DD") + time,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm")
      ) {
        show = true;
      }

      return show;
    },
    display: function(time) {
      let show = true;

      if (
        this.actualDate.format("YYYY-MM-DD HH:mm") >
        moment(
          this.selectedDate.format("YYYY-MM-DD") + time,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm")
      ) {
        show = false;
      }

      if (this.showAll) {
        show = true;
      }

      return show;
    },
    cardClick() {
      //this.clicked = true;
      if (
        this.actualDate.format("YYYY-MM-DD HH:mm") >
        moment(
          this.selectedDate.format("YYYY-MM-DD") + this.time,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm")
      ) {
        return false;
      } else {
        if (
          this.privado ||
          this.reservados >= this.personLimit ||
          this.disponible < this.players
        ) {
          this.$swal({
            title: "¡No hay espacio para los jugadores indicados!",
            text: "¿Deseas continuar reservando en este horario?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Continuar",
            showLoaderOnConfirm: true,
            preConfirm: async () => {},
          }).then((result) => {
            if (result.value) {
              let isPrefered = this.prefered;
              this.$emit(
                "clicked",
                this.$vnode.key,
                this.time,
                this.tarifaId,
                isPrefered
              );
              this.$store.commit("setPriceSelected", this.total);
            }
          });
          return false;
        }
      }

      let isPrefered = this.prefered;
      this.$emit(
        "clicked",
        this.$vnode.key,
        this.time,
        this.tarifaId,
        isPrefered
      );
      this.$store.commit("setPriceSelected", this.total);
    },
    selectTime(iniTime, endTime, bay) {
      //al seleccionar un horario
      if (this.selectedTimes.length > 1) {
        // si los horarios seleccionados son mas de dos, reinicia el array
        this.selectedTimes = [];
        this.$emit("cleanTimesRange");
      } else {
        // si aun esta seleccionando fecha inicial y final
        if (this.selectedTimes.length != 0) {
          //si ya selecciono la primera hora
          let firstTime = new moment(this.selectedTimes[0].time, "HH:mm");
          let newTime = new moment(endTime, "HH:mm");
          //valida que la hora inicial no sea mayor que la final
          if (firstTime > newTime) {
            this.selectedTimes = [];
            return false;
          }

          // verifica que el rango seleccionado sea de mas de una hora como minimo
          let duration = moment.duration(newTime.diff(firstTime));
          var hours = duration.asHours();

          /*if (hours < 1) {
            this.$swal({
              icon: "error",
              title: "Seleccione al menos una hora",
              text: "El tiempo minimo de juego es de una hora ",
            });
            return false;
          }*/
          let resCount = 0;
          this.reservas.forEach((reserv) => {
            let resInicial = new moment(reserv.inicial, "HH:mm");
            let inicalRange = new moment(this.selectedTimes[0].time, "HH:mm");
            let finalRange = new moment(iniTime, "HH:mm");
            this.$pgsHelper.log(reserv.bahia);
            this.$pgsHelper.log(bay);
            if (
              resInicial > inicalRange &&
              resInicial < finalRange &&
              reserv.bahia == bay + 1
            ) {
              resCount++;
            }
          });

          if (resCount > 0) {
            this.$swal({
              icon: "error",
              title: "Rango de horas no permitido",
              text:
                "Existe una reserva dentro del rango de horas que seleccionaste ",
            });
            return false;
          }
        }
      }

      let tipo = "inicial";
      let hora = iniTime;
      if (this.selectedTimes.length > 0) {
        tipo = "final";
        hora = endTime;
      }
      this.selectedTimes.push({
        time: hora,
        endTime: endTime,
        bay: bay + 1,
        tipo: tipo,
        date: this.selectedDate,
      });

      this.$forceUpdate();
      if (this.selectedTimes.length >= 1) {
        this.$emit("selectTimesRange", this.selectedTimes);
      }
    },
  },
  computed: {
    reservas() {
      let reserva = [];
      this.reservasData.forEach((element) => {
        if (element.Rvs) {
          let reservaData = Object.entries(element.Rvs);
          
          let reservasAgrupadas = [];
          element.rvsData.forEach((ply) => {
            if (!this.$pgsHelper.getById(reservasAgrupadas, "id", ply.id)) {
              reservasAgrupadas.push(ply);
            }
          });
          reserva.push({
            inicial: element.time,
            final: element.timeEnd,
            bahia: element.bahia,
            players: element.PAX,
            playersName: element.Players,
            dataReserva: reservasAgrupadas,
          });
        } else if (element.Privado) {
          reserva.push({
            inicial: element.time,
            final: element.timeEnd,
            bahia: element.bahia,
            players: 0,
            Privado: element.Privado,
            playersName: [],
            dataReserva: [],
            
          });
        }
      });
      return reserva;
    },
    horas() {
      let Times = this.times;
      let newTimes = [];
      //por cada hora
      Times.forEach((hora, index) => {
        //asignamos el objeto a un duplicado para evitar errores de ciclado
        let newHora = { time: hora.time, timeEnd: hora.timeEnd, ...hora };
        //agregamos el array "block" y "players" donde almacenaremos si la hora esta bloqueada en una bahia y cuantos jugadores tiene
        newHora.block = [];
        newHora.players = [];
        newHora.selected = [];
        newHora.final = [];
        newHora.inRange = [];
        newHora.playersName = [];
        newHora.ResData = [];
        // bloqueo y señalizacion de reservas dentro del componente
        this.reservas.forEach((res) => {
          let time = new moment(hora.time, "HH:mm");
          let resInitial = new moment(res.inicial, "HH:mm");
          let resFinal = new moment(res.final, "HH:mm");
          let ocupado = 0;
          // si la hora esta dentro del rango de la hora de una reserva
          if (time >= resInitial && time < resFinal) {
            //agregamos al array un indice de las bahias que estan ocupadas a esas horas

            let reservasEnHora = Object.entries(res.dataReserva);
            reservasEnHora.forEach((reservacion) => {
              
              if (reservacion[1].E != "C") {
                newHora.players[res.bahia] = res.players;
                newHora.playersName[res.bahia] = reservacion[1].Nom;
                newHora.ResData[res.bahia] = res;
                ocupado++;
              }
              
            });
            if (res.Privado) {
              newHora.Privado = res.Privado
              ocupado++;
            }
            
            if (ocupado > 0) {
              newHora.block[res.bahia] = true;
            }

            //agregamos al array un indice de los jugadores que estan en cada bahia
            
            /*if(res?.dataReserva[0].E != "C"){
              newHora.
            }*/
          }
        });
        // logica para señalizacion de rango seleccionado

        this.selectedTimes.forEach((stime) => {
          let time = new moment(newHora.time, "HH:mm");
          let timeEnd = new moment(newHora.timeEnd, "HH:mm");
          let stimeTime = new moment(stime.time, "HH:mm");
          // si el horario esta en el array de seleccionado
          let comparingTime = time;
          if (stime.tipo == "inicial") {
            comparingTime = time;
          } else {
            comparingTime = timeEnd;
          }
          if (comparingTime.format("HH:mm") == stimeTime.format("HH:mm")) {
            //lo agregamos a inicial o final
            if (stime.tipo == "inicial") {
              newHora.selected[stime.bay] = true;
            } else {
              newHora.final[stime.bay] = true;
            }
          }
        });
        /* si ya estan seleccionado hora inicial y final,
             agregamos la badera para indicar que la celda esta dentro del rango y la colorea */
        if (this.selectedTimes.length == 2) {
          let time = new moment(newHora.time, "HH:mm");
          let timeEnd = new moment(newHora.timeEnd, "HH:mm");
          let inicial = new moment(this.selectedTimes[0].time, "HH:mm");
          let final = new moment(this.selectedTimes[1].time, "HH:mm");
          if (time > inicial && timeEnd < final) {
            newHora.inRange[this.selectedTimes[0].bay] = true;
          }
        }

        // agregamos toda la informacion de la hora para renderizar el tr
        newTimes.push(newHora);
      });

      return newTimes;
    },
    compSizeOfColumns() {
      let size = "10%";
      let wSize = 90 / Number(this.slotsNumber);
      return wSize + "%";
    },
    comp_bahias() {
      let bahias = [];
      for (let index = 1; index <= this.slotsNumber; index++) {
        bahias.push({ Name: "B" + index });
      }
      return bahias;
    },
    typePaid() {
      return this.$store.getters.getTypePaid;
    },
    globalPrice() {
      return this.$store.getters.getGlobalPrice;
    },
  },
  watch: {
    selectedSlot() {
      this.selectedTimes = [];
    },
  },
  mounted() {
    this.init();
  },
  created() {
    setInterval(() => {
      let fecha = new moment();
      this.actualDate = fecha; //.format("YYYY-MM-DD HH:mm:ss");
    }, 1000);
  },
};
</script>

<style scoped>
.timeCell {
  border-top: 1px solid rgba(34, 36, 38, 0.1) !important;
  left: 0 !important;
  top: auto !important;
  position: sticky !important;
  background: #e6e6e6 !important;
}

@media only screen and (max-width: 767px) {
  .uvtable:not(.unstackable) tbody,
  .uvtable:not(.unstackable) tr,
  .uvtable:not(.unstackable) tr > td,
  .uvtable:not(.unstackable) tr > th {
    width: auto !important;
    display: revert !important;
  }

  .uvtable:not(.unstackable) thead {
    display: revert !important;
  }
}

.disableClick {
  pointer-events: none !important;
}
.cell {
  padding: 6px 0.13px !important;
}
.selectedTime {
  background: #21ba45 !important;
}
.selectedRange {
  background: #21ba458a !important;
}
.ocuped {
  background: #ff000091 !important;
  cursor: default !important;
  pointer-events: all !important;
  /*pointer-events:none !important;*/
}
.selectBay {
  background: #ffffff80;
  cursor: pointer;
}
.selectBayHeader {
  background: #2185d094;
  cursor: pointer;
}
.disableBay {
  background: #d4d4d5;
  pointer-events: none;
}
th {
  text-align: left;
  font-weight: normal;
  font-size: 12px;
}
.pt-card :hover {
  box-shadow: 0 1px 3px 0 #009688, 0 0 0 1px #009688 !important;
}

.pt-card .content :hover {
  box-shadow: none !important;
}

.cardActive {
  box-shadow: 0 1px 3px 0 #009688, 0 0 0 1px #009688 !important;
}
.cardActive i {
  display: inherit !important;
}
.disponibilidad {
  font-size: 11px;
}
.unavailable {
  color: red;
}
.available {
  color: #009688;
}
.time {
  font-size: 14px !important;
}
.meta {
  font-size: 12px !important;
}
.total {
  margin: 0;
  font-size: 12px !important;
}
.description {
  margin-top: 0px !important;
}

.cardEnable {
  cursor: pointer;
}

.noShow {
  display: none !important;
}

.cardPrefered {
  cursor: pointer;
  box-shadow: 0 1px 3px 0 #21ba45, 0 0 0 1px #21ba45 !important;
  background: #00b5ad5e !important;
}

.cardDisabled {
  cursor: not-allowed !important;
  background: #607d8b59 !important;
  pointer-events: none;
}

.cardsemiDisabled {
  /*cursor: not-allowed !important;*/
  background: #607d8b59 !important;
  /*pointer-events:none*/
}

@media only screen and (max-width: 767px) {
  .noShow {
    display: none !important;
  }
}
</style>
